import Buy from "../pages/Buy";
import Catalog from "../pages/Catalog/Catalog";
import HowItWorks from "../pages/Informative/HowItWorks";
import Shop from "../pages/Shop";

const routes = [
  {
    path: "/",
    component: <Catalog />,
    exact: true,
  },
  {
    path: "/shop/:id",
    component: <Shop />,
    exact: true,
  },
  {
    path: "/buy/:id",
    component: <Buy />,
    exact: true,
  },
  {
    path: "/info",
    component: <HowItWorks />,
    exact: true,
  },
];

export default routes;
